import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_RESEND,
  FORGET_PASSWORD_UPDATE,
} from "./actionTypes"
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  ForgotPasswordUpdateError,
  ForgotPasswordUpdateSuccess,
} from "./actions"
import {
  LystfaceForgotPassword,
  LystfaceForgotPasswordUpdate,
} from "../../../helpers/lystface_helper"

//Include Both Helper File with needed methods

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    const UserForgot = yield call(LystfaceForgotPassword, user)
    if (UserForgot.responseCode) {
      yield put(userForgetPasswordSuccess({ user: user.email, responseMessage: UserForgot.responseMessage }))
    } else {
      console.log(UserForgot)
      yield put(userForgetPasswordError(UserForgot.responseMessage))
    }
  } catch (error) {
    console.log(error)
  }
}
function* forgetUserResend({ payload: { user, history } }) {
  try {
    const UserForgot = yield call(LystfaceForgotPassword, user)
    console.log(UserForgot)
    if (UserForgot.responseCode) {
      yield put(userForgetPasswordSuccess({ user: user.email, responseMessage: UserForgot.responseMessage }))
    } else {
      yield put(userForgetPasswordError(UserForgot.responseMessage))
      history("/login")
    }
  } catch (error) {
    yield put(userForgetPasswordError(error.message))
    console.log(error)
  }
}
function* forgetPasswordUpdate({ payload: { user, history } }) {
  try {
    const ForgotPwdUpdate = {
      pwd: user.Password,
    }
    const UserForgotUpdate = yield call(
      LystfaceForgotPasswordUpdate,
      user.passId,
      ForgotPwdUpdate
    )
    console.log(UserForgotUpdate)
    if (UserForgotUpdate.responseCode == true) {
      yield put(ForgotPasswordUpdateSuccess())
    } else {
      yield put(ForgotPasswordUpdateError(UserForgotUpdate.responseMessage))
    }
  } catch (error) {
    console.log(error)
  }
}

function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
  yield takeEvery(FORGET_PASSWORD_RESEND, forgetUserResend)
  yield takeEvery(FORGET_PASSWORD_UPDATE, forgetPasswordUpdate)
}

export default forgetPasswordSaga
